@import '~style-sheet-helpers/core';
@import '../../../../app-brand/entities/entity-layer.module.less';
@import '../../../../constants/spacing.module.less';

.insurance-label {
  padding-right: @space-8;
}

.claim-icon {
  height: 10px;
  margin-left: 4px;
  color: var(--blue-600);
}
